/* eslint-disable class-methods-use-this */
/* eslint-disable no-unused-vars */

import basic from '../../data/basic.json';
import СolorSlider from './components/colorSlider';
import Screen from './components/screens/screen';
import FinishScreen from './components/screens/finishScreen';
import { formatGameTime } from '../game/helpers/formatters';
import { screenNames, bgNames } from './constants/screens';
import { getIsGamePt } from '../game/constants/gameSettings';

const screensToBgList = {
    [screenNames.GAME]: bgNames.GAME,
    [screenNames.RESULTS]: bgNames.GAME,
    [screenNames.FINISH]: bgNames.GAME,
    [screenNames.AUTHORS]: bgNames.GAME,
    [screenNames.SCORING]: bgNames.WINNERS,
    [screenNames.WINNERS]: bgNames.WINNERS,
    default: bgNames.INTRO
};

export default class AppViewController {
    #isGuest = false;

    #globalStylesEl = document.body;
    #headerEl;
    isPt;
    #screens;
    #backgrounds;
    #headerInGameClass = 'in-game';
    #headerInPauseClass = 'in-pause';
    #headerInFinishClass = 'in-finish';
    #activeClassName = 'is-active';
    #screensHistory = [];
    #prevScreenButtons;
    #isDemoMode = false;

    constructor(options) {
        this.activeScreenName = '';
        this.isPt = getIsGamePt();

        this.#isDemoMode = options.isDemoMode || false;

        // this.bgScreen = null;
        this.pauseScreen = null;

        this.updateCurrentMode();
        this.initScreens();
        this.initBackgrounds();
        this.initPrevScreenButtons();
        this.initColorSliders();
        this.getHeader();
        this.initListeners();
        // this.updateGuestState();

        // this.updateResultTime(60.59);
    }

    set isGuest(isGuest) {
        this.#isGuest = isGuest;

        this.updateGuestState();
    }

    updateCurrentMode() {
        if (this.#isDemoMode) {
            this.#globalStylesEl.classList.add('demo-mode');
        }
    }

    initListeners() {
        window.addEventListener('resize', this.updateLayoutType.bind(this));
    }

    updateLayoutType() {
        this.isPt = getIsGamePt();
    }

    initColorSliders() {
        const mainSliderEl = document.querySelector('#bus-color-slider-main');
        const secondarySliderEl = document.querySelector('#bus-color-slider-secondary');

        // eslint-disable-next-line no-new
        new СolorSlider(mainSliderEl);
        // eslint-disable-next-line no-new
        new СolorSlider(secondarySliderEl, { initialSlide: 1 });
    }

    initPrevScreenButtons() {
        this.#prevScreenButtons = Array.from(document.querySelectorAll('.js-prev-screen-button'));

        this.#prevScreenButtons.forEach((button) => {
            button.addEventListener('click', this.onPrevScreenClick.bind(this));
        });
    }

    onPrevScreenClick() {
        console.log(this.#screensHistory);

        this.#screensHistory.pop(); // Удаляем экран, на который только что вернулись
        this.#screensHistory.pop(); // Удаляем экран, с которого вернулись
        console.log(this.#screensHistory);
    }

    getHeader() {
        this.#headerEl = document.getElementById('header');
    }

    updateGuestState() {
        const goAuthButton = document.querySelector('.js-start-auth-button');

        if (this.#isDemoMode) {
            this.#globalStylesEl.classList.remove('user-logged');
            goAuthButton.dataset.screen = 'rules';
        } else if (this.#isGuest) {
            this.#globalStylesEl.classList.remove('user-logged');
            goAuthButton.dataset.screen = 'auth';
        } else {
            this.#globalStylesEl.classList.add('user-logged');
            goAuthButton.dataset.screen = 'rules';
        }
    }

    updateUserData(data) {
        Array.from(document.querySelectorAll('.js-user-name')).forEach((block) => {
            block.innerHTML = data.name;
            // block.innerHTML = 'fsdgsgsgngnsdjgskdgsgsgdsbnigbsdgsdibgidsbgdsuoign';
        });
    }

    updateResultTime(time) {
        const timeFormatted = formatGameTime(time);

        Array.from(document.querySelectorAll('.js-time-display')).forEach((el) => {
            el.innerHTML = timeFormatted;
        });
    }

    onCookieAccept() {
        this.#globalStylesEl.classList.add('cookies-accepted');
    }

    initScreens() {
        this.#screens = Array.from(document.querySelectorAll('.screen')).reduce((accumulator, screenEl) => {
            const name = screenEl.dataset.screen;

            let screen;

            switch (name) {
                case screenNames.FINISH:
                    screen = new FinishScreen(screenEl);

                    break;
                default:
                    screen = new Screen(screenEl);
            }

            return [...accumulator, screen];
        }, []);
        this.pauseScreen = document.querySelector('.screen-pause');
    }

    initBackgrounds() {
        this.#backgrounds = Array.from(document.querySelectorAll('.js-screens-bg'));
    }

    setActiveBg(name) {
        const activeBgEl = this.#backgrounds.find((el) => el.dataset.name === name);

        if (!activeBgEl) return;

        this.#backgrounds.forEach((el) => {
            el.classList.remove(this.#activeClassName);
        });

        activeBgEl.classList.add(this.#activeClassName);
    }

    setActiveScreen(screenName) {
        const newActiveScreen = this.#screens.find((screen) => screen.name === screenName);

        if (!newActiveScreen || this.activeScreenName === screenName) return;

        this.activeScreenName = screenName;

        this.#screens.forEach((screen) => {
            screen.setIsActive(screen.name === this.activeScreenName, this.isPt);
        });

        this.#globalStylesEl.dataset.activeScreen = screenName;

        const activeBgName = screensToBgList[screenName] || screensToBgList.default;

        this.setActiveBg(activeBgName);

        this.#screensHistory.push(screenName);
        this.updateButtons();

        // console.log(this.#screensHistory);
    }

    updateButtons() {
        const prevScreenName = this.#screensHistory.at(-2);

        if (!prevScreenName) return;

        this.#prevScreenButtons.forEach((button) => {
            button.setAttribute('data-screen', prevScreenName);
        });
    }

    // showFinishStyles() {
    //     this.#globalStylesEl.classList.add('game-finished');
    // }

    // hideFinishStyles() {
    //     this.#globalStylesEl.classList.remove('game-finished');
    // }

    // onGameStart() {
    //     // this.#headerEl.classList.remove(this.#headerInFinishClass);
    //     // this.#headerEl.classList.remove(this.#headerInPauseClass);
    //     // this.#headerEl.classList.add(this.#headerInGameClass);
    //     // this.#globalStylesEl.classList.remove('game-finished');
    //     // this.hideFinishStyles();
    // }

    // onGameFinish() {
    //     // this.#headerEl.classList.remove(this.#headerInPauseClass);
    //     // this.#headerEl.classList.remove(this.#headerInGameClass);
    //     // this.#headerEl.classList.add(this.#headerInFinishClass);
    //     // this.#globalStylesEl.classList.add('game-finished');
    // }

    showPauseScreen() {
        // this.setActiveScreen(screenNames.PAUSE);
        this.activeScreenName = screenNames.PAUSE;
    }

    hidePauseScreen() {
        // this.setActiveScreen(screenNames.GAME);
        this.activeScreenName = screenNames.GAME;
    }
}
